import {
  START_LOAD_EVENTS, END_LOAD_EVENTS, ADMIN_UPDATE_EVENT_SUCCESS, ADMIN_UPDATE_EVENT_FAILURE
} from '../actions/events';

let eventsReducer = (state={isLoading: false, eventsArray: []}, action) => {
  switch(action.type) {
    case START_LOAD_EVENTS:
      return {
        isLoading: true
      }
    case END_LOAD_EVENTS:
      return {
        isLoading: false,
        eventsArray: action.eventsArray,
      }
    case ADMIN_UPDATE_EVENT_SUCCESS:
      console.log('filtered events reducer admin update event success!', action.event);
      console.log(state);
      return {
        eventsArray: state.eventsArray.map((event) => {
          if (event.id === action.event.id) {
            return action.event;
          } else {
            return event;
          }
        })
      }  
    case ADMIN_UPDATE_EVENT_FAILURE:
      console.log('filtered events reducer admin update event failure!');
      return state;
    
    default:
      return state;
  }
}

export default eventsReducer
